import React from "react";

export const Footer = () => {

  return (
    <footer className="bg-gray-600 text-white py-2">
      <div className="container mx-auto text-center">
        © PonziLover.com <span className="text-sm">(01.127)</span>
      </div>
    </footer>
  );
};
